import { apolloAGGCache } from '../src/getAGGClient.ts';

export { getAGGClient } from '../src/getAGGClient.ts';

export function getApolloAGGCache() {
	return apolloAGGCache;
}
